<template>
    <div>
        <!--Subscribe section start-->
        <section>
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <div class="footer-text">
                            <img :src='"../assets/images/email.png"' alt="email">
                            <h2 class="title text-center md-margin-top">subscribe to <span>newsletter</span></h2>
                            <p>Get upto date relevant industry updates. We also offer to help on things like Firmware upgrades that might effect your customers before they even call you!</p>
                            <form target="_blank" method="post" action="https://xtremecontrols.us7.list-manage.com/subscribe/post" class="footer-form">
                                <input type="hidden" name="u" value="eb0abcb4852c2a47aa1343ffa">
                                <input type="hidden" name="id" value="5927bf0f94">
                                <div class="form-group">
                                    <!--<input type="EMAIL" id="mce-EMAIL" class="form-control" required placeholder="enter your email">-->
                                    <input class="form-control" name="MERGE0" id="mce-EMAIL" placeholder="Your email address:" type="email" required="required" >
                                </div>
                                <div class="form-button">
                                    <button type="submit"  class="btn btn-custom theme-color">send</button>
                                </div>
                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    <!--Subscribe section Ends-->
    </div>
</template>
<script>
export default {
    name: "Subscribe"
}
</script>



// WEBPACK FOOTER //
// src/components/subscribe.vue